
document.addEventListener('DOMContentLoaded', () => {

    // Elements
    const popup      = document.getElementById('stepPopup');
    if(!popup){ return; }
    const popupInner = document.getElementById('stepPopupInner');
    const popupImg   = document.getElementById('popupImg');
    const popupTitle = document.getElementById('popupTitle');
    const popupDesc  = document.getElementById('popupDesc');

    // Open Popup
    window.openStepPopup = function (el) {
        popupImg.src = el.dataset.img || '';
        popupTitle.textContent = el.dataset.title || '';
        popupDesc.textContent = el.dataset.desc || '';

        popup.classList.remove('hidden');

        requestAnimationFrame(() => {
            popupInner.classList.remove('opacity-0', 'scale-95');
            popupInner.classList.add('opacity-100', 'scale-100');
        });
    };

    // Close Popup
    window.closeStepPopup = function () {
        popupInner.classList.add('opacity-0', 'scale-95');
        popupInner.classList.remove('opacity-100', 'scale-100');

        setTimeout(() => popup.classList.add('hidden'), 200);
    };

    // Close on background click
    popup.addEventListener('click', (e) => {
        if (e.target === popup) window.closeStepPopup();
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') window.closeStepPopup();
    });

});